import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./LoginHeader.css";
import logoimg from "../../Logo/logo.jpg";
import { UserRegGet } from "../../Api/CoreApi";
import { LogOut, X } from "lucide-react";

const LoginHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
 const [scrolled, setScrolled] = useState(false);
  const [devref, setDevref] = useState(0);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  // ✅ Sahi key se check karo
  const getLoginStatus = () => {
    const token = localStorage.getItem("access_token"); // ← FIXED
    return Boolean(token && token !== "null" && token !== "undefined");
  };

  const [isLoggedIn, setIsLoggedIn] = useState(getLoginStatus());

  useEffect(() => {
    const get = async () => {
      try {
        const response1 = await UserRegGet();
        const dev_get = response1.filter((i) => i.role === "developer");
        const dev_id = dev_get.map((i) => i.refer);
        setDevref(parseInt(dev_id));
      } catch (error) {
        console.error("Error fetching dev ref:", error);
      }
    };
    get();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ✅ Route change pe check karo
  useEffect(() => {
    setIsLoggedIn(getLoginStatus());
  }, [location.pathname]);

  // ✅ Events pe check karo
  useEffect(() => {
    const checkLoginStatus = () => {
      setIsLoggedIn(getLoginStatus());
    };

    checkLoginStatus();

    window.addEventListener("storage", checkLoginStatus);
    window.addEventListener("authChanged", checkLoginStatus);

    return () => {
      window.removeEventListener("storage", checkLoginStatus);
      window.removeEventListener("authChanged", checkLoginStatus);
    };
  }, []);

  const openLogoutPopup = () => setShowLogoutPopup(true);
  const closeLogoutPopup = () => setShowLogoutPopup(false);

  // ✅ Logout me sahi keys remove karo
  const confirmLogout = () => {
    localStorage.removeItem("access_token");  // ← FIXED
    localStorage.removeItem("refresh_token"); // ← FIXED
    localStorage.removeItem("role");
    localStorage.removeItem("user_id");
    localStorage.removeItem("ref");
    localStorage.removeItem("username");
    localStorage.removeItem("user_gender");
    localStorage.removeItem("user_caste");
    localStorage.removeItem("cached_user_id");

    setIsLoggedIn(false);
    setShowLogoutPopup(false);

    window.dispatchEvent(new Event("authChanged"));
    navigate("/User_Login");
  };

  return (
    <>
      <header className={`main-header ${scrolled ? "scrolled" : ""}`}>
        <div className="header-blur-circle circle-one"></div>
        <div className="header-blur-circle circle-two"></div>

        <div className="header-inner">
          <Link to="/" className="brand-wrap">
            <div className="logo">
              <img src={logoimg} alt="Logo" />
            </div>
            <div className="brand-text">
              <h2>Community <span>Rishtey</span></h2>
              <p>Trusted Matrimony Platform</p>
            </div>
          </Link>

          <div className="auth-links">
            {!isLoggedIn ? (
              <>
                <Link to="/User_Reg" className="auth-link auth-link-outline">
                  Sign Up
                </Link>
                <Link to="/User_Login" className="auth-link auth-link-fill">
                  Login
                </Link>
              </>
            ) : (
              <button
                onClick={openLogoutPopup}
                className="auth-link auth-link-fill logout-btn"
              >
                Logout
              </button>
            )}
          </div>
        </div>
      </header>

      {showLogoutPopup && (
        <div className="logout-popup-overlay" onClick={closeLogoutPopup}>
          <div className="logout-popup" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close-btn" onClick={closeLogoutPopup}>
              <X size={20} />
            </button>
            <div className="popup-icon">
              <LogOut size={40} />
            </div>
            <h3>Are you sure?</h3>
            <p>Do you really want to logout from your account?</p>
            <div className="popup-buttons">
              <button className="popup-btn popup-btn-no" onClick={closeLogoutPopup}>
                No, Stay
              </button>
              <button className="popup-btn popup-btn-yes" onClick={confirmLogout}>
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginHeader;